import {Button, icons} from '@superweb/ui'
import React, {useCallback, useState} from 'react'

import type {MapEvents, MapLocationRequest} from '../../../model'
import {DEFAULT_ZOOM, DEFAULT_ZOOM_DURATION} from '../../../model'
import {MapListener} from '../../index'
import styleClasses from './classes.module.css'

type Props = {
  duration?: number
  setLocation: (location: MapLocationRequest) => void
  zoomRange?: [min: number, max: number]
}

function MapZoomCustomControl({duration = DEFAULT_ZOOM_DURATION, setLocation, zoomRange = [0, 21]}: Props) {
  const [currentZoom, setCurrentZoom] = useState<number>(DEFAULT_ZOOM)

  const onUpdate: MapEvents['onUpdate'] = useCallback(updateObject => {
    setCurrentZoom(updateObject.location.zoom)
  }, [])

  const changeZoom = useCallback(
    (delta: number) => {
      const newZoom = Math.min(Math.max(currentZoom + delta, zoomRange[0]), zoomRange[1])
      setLocation({
        zoom: newZoom,
        duration,
      })
    },
    [currentZoom, duration, setLocation, zoomRange],
  )

  const onZoomIn = useCallback(() => {
    changeZoom(1)
  }, [changeZoom])
  const onZoomOut = useCallback(() => {
    changeZoom(-1)
  }, [changeZoom])

  const isZoomInDisabled = currentZoom >= zoomRange[1]
  const isZoomOutDisabled = currentZoom <= zoomRange[0]

  return (
    <div className={styleClasses.container}>
      <div className={styleClasses.zoomControl}>
        <Button disabled={isZoomInDisabled} icon={icons.PlusL} onPress={onZoomIn} shape="circle" view="floating" />
        <Button disabled={isZoomOutDisabled} icon={icons.MinusL} onPress={onZoomOut} shape="circle" view="floating" />
        <MapListener onUpdate={onUpdate} />
      </div>
    </div>
  )
}

export default React.memo(MapZoomCustomControl)
